<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <layout-header></layout-header>
          <breadcrumb></breadcrumb>
          <!-- Page Content -->
          <div class="content">
            <div class="container patient-dashboard">
              <div class="row">
                <!-- Profile Sidebar -->
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar1></sidebar1>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <!-- / Profile Sidebar -->
                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="text-left ml-md-4">
                    <a href="#" data-toggle="modal" data-target="#addvitals" class="btn btn-primary" tabindex="0">Add
                      Vital</a>
                  </div>
                  <div class="row patient-dashboard-cards m-md-2">
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Pulse Rate</h4>
                          <h4 v-if="patient_data.pulse_history == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h4>
                          <div v-else>
                            <h4>
                              {{ patient_data.pulse_history }} <sub>bpm</sub>
                            </h4>
                            <span style="font-size:12px;">{{ formattedPulseDate }}</span>

                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Pulse.png" alt="" width="65" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#pulse-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Body Temperature</h4>
                          <h6 v-if="patient_data.temperature_history == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>
                              {{ patient_data.temperature_history }} <sub>C</sub>
                            </h6>
                            <!-- Example usage in the template -->
                            <span style="font-size:12px;">{{ formattedTempDate }}</span>

                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Body_temp.jpg" alt="" width="50" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#temperature-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Blood Pressure</h4>
                          <h6 v-if="patient_data.bp == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>{{ patient_data.bp }}</h6>
                            <span style="font-size:12px;">{{ formattedBpDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/blood_pressure.png" alt="" width="70" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer;  background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#bp-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Fasting Blood Sugar</h4>
                          <h6 v-if="patient_data.fasting_blood_sugar_fbs_history == 0"
                            style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>
                              {{ patient_data.fasting_blood_sugar_fbs_history }}
                            </h6>
                            <span style="font-size:12px;">{{ formattedFbsDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Fasting_blood_sugar.jpg" alt="" width="50" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer;  background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#fasting-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Random Blood Sugar</h4>
                          <h6 v-if="patient_data.random_blood_sugar_rbs_history == 0"
                            style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>
                              {{ patient_data.random_blood_sugar_rbs_history }}
                              <sub></sub>
                            </h6>
                            <span style="font-size:12px;">{{ formattedRbsDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Fasting_blood_sugar.jpg" alt="" width="50" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor:pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#random-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Hba1c</h4>
                          <h6 v-if="patient_data.hba1c_history == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>{{ patient_data.hba1c_history }} <sub></sub></h6>
                            <span style="font-size:12px;">{{ formattedHba1cDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Hba1c.jpg" alt="" width="70" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#Hba1c-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">Weight (KG)</h4>
                          <h6 v-if="patient_data.weight_history == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>{{ patient_data.weight_history }} <sub></sub></h6>
                            <span style="font-size:12px;">{{ formattedWeightDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/Weight.jpg" alt="" width="50" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#Weight-graph">
                          Graph
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-4 col-xl-4 patient-dashboard-top">
                      <div class="card">
                        <div class="card-body text-center">
                          <h4 class="mt-2">BMI</h4>
                          <h6 v-if="patient_data.bmi_history == 0" style="color: #808080; font-size:medium;">
                            Not Taken
                          </h6>
                          <div v-else>
                            <h6>{{ patient_data.bmi_history }} <sub></sub></h6>
                            <span style="font-size:12px;">{{ formattedBmiDate }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/specialities/BMI.jpg" alt="" width="50" />
                          </div>
                        </div>
                        <div class="card-footer text-center"
                          style="cursor: pointer; background-color: #f8f8f8;color:black;" href="#" data-toggle="modal"
                          data-target="#bmi-graph">
                          {{ patient_data.bmi_unit }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card m-2" id="appointment_container" style="border: none;">
                    <div class="card-body pt-0">
                      <!-- Tab Menu -->
                      <nav class="user-tabs">
                        <ul class="nav nav-tabs nav-tabs-bottom">
                          <li class="nav-item">
                            <a class="nav-link active" href="#pat_appointments" data-toggle="tab">Appointments</a>
                          </li>
                        </ul>
                      </nav>
                      <!-- /Tab Menu -->

                      <!-- Tab Content -->
                      <div class="tab-content pt-1">
                        <!-- Appointment Tab -->
                        <div id="pat_appointments" class="tab-pane fade show active">
                          <div class="card card-table mb-0" style="border: none;">
                            <div class="card-body">
                              <div class="table-responsive">
                                <table class="table table-hover  mb-0">
                                  <thead>
                                    <tr>
                                      <th class="text-left">Doctor</th>
                                      <th class="text-left">Slot No</th>
                                      <th class="text-left">Hospital</th>
                                      <th class="text-left">Appt Date</th>
                                      <th class="text-left">Status</th>
                                      <th class="text-left">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(item,
                                      $index) in patient_appointment_list" :key="item.id" v-show="setPaginate($index)">
                                      <td class="text-left">
                                        <h2 class="table-avatar">
                                          <router-link :to="{
                                            name: 'doctor-profile',
                                            params: {
                                              name: item.practitioner,
                                            },
                                          }" class="avatar avatar-sm mr-2">
                                            <img class="avatar-img rounded-circle" :src="item.doctor_photo
                                              ? config.base_url_for_Image +
                                              item.doctor_photo
                                              : loadImg(
                                                'Doctor Profile.svg'
                                              )
                                              " alt="User Image" />
                                          </router-link>
                                          <router-link :to="{
                                            name: 'doctor-profile',
                                            params: {
                                              name: item.practitioner,
                                            },
                                          }">{{ item.practitioner_name }}
                                            <span>{{ item.department }}
                                            </span>
                                          </router-link>
                                        </h2>
                                      </td>
                                      <td>{{ item.custom_slot_no }}</td>
                                      <td>{{ item.hospital }}</td>
                                      <td class="text-left">
                                        {{
                                          convertDate(item.appointment_datetime) }}
                                        <span class="d-block text-info">
                                          {{ convertTime(item.appointment_datetime) }}
                                        </span>
                                      </td>
                                      <td class="text-left">
                                        {{ item.status }}
                                      </td>
                                      <td class="text-left">
                                        <div class="table-action">
                                          <a href="#" data-toggle="modal" data-target="#viewappointment" @click="
                                            viewappointmentdata(
                                              item.name,
                                              false
                                            )
                                            " class="btn btn-sm bg-info-light" style="min-width: 80px;">
                                            <i class="fas fa-file-pdf"></i> View and Print
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h5 v-if="patient_appointment_list.length === 0" class="No_data">
                                  No Appointments Found
                                </h5>
                              </div>
                              <!-- pagination start -->
                              <div id="pagination" v-if="patient_appointment_list.length > 10">
                                <ul class="pagination justify-content-center">

                                  <!-- "Previous" Button -->
                                  <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                                    <a href="#" class="page-link" aria-label="Previous"
                                      @click.prevent="updateCurrent(current - 1)">
                                      Previous
                                    </a>
                                  </li>
                                  <!-- Pagination Links (Display 5 at a time) -->
                                  <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                                    'page-item',
                                    current === page_index ? 'active' : ''
                                  ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                                    <a href="#" class="page-link" @click.prevent="updateCurrent(page_index)">
                                      {{ page_index }}
                                    </a>
                                  </li>
                                  <!-- "Next" Button -->
                                  <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                                    ">
                                    <a href="#" class="page-link" aria-label="Next"
                                      @click.prevent="updateCurrent(current + 1)">
                                      Next
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <!-- pagination end -->
                            </div>
                          </div>
                        </div>
                        <!-- /Appointment Tab -->
                      </div>
                      <!-- Tab Content -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>

      <!-- Pulse-status -->
      <div class="modal fade custom-modal show" id="pulse-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Pulse Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="pulseflow.series" :options="pulseflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /Pulse-status-->

      <!-- temperature-status -->
      <div class="modal fade custom-modal show" id="temperature-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Body Temperature Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="tempflow.series" :options="tempflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /temperature-status-->

      <!-- bp-status -->
      <div class="modal fade custom-modal show" id="bp-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Blood Pressure Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="bpflow.series" :options="bpflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /bp-status-->

      <!-- fasting-status -->
      <div class="modal fade custom-modal show" id="fasting-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Fasting Blood Sugar Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="fbsflow.series" :options="fbsflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /fasting-status-->

      <!-- random-status -->
      <div class="modal fade custom-modal show" id="random-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Random Blood Sugar Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="rbsflow.series" :options="rbsflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /random-status-->

      <!-- Hba1c-status -->
      <div class="modal fade custom-modal show" id="Hba1c-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Hba1c Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="Hba1cflow.series" :options="Hba1cflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /Hba1c-status-->

      <!-- Weight-status -->
      <div class="modal fade custom-modal show" id="Weight-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Weight Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="weightflow.series" :options="weightflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /Weight-status-->

      <!-- bmi-status -->
      <div class="modal fade custom-modal show" id="bmi-graph">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">BMI Status</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" style="background-color: #f8f8f8;">
              <apexchart type="line" height="350" :series="bmiflow.series" :options="bmiflow.options"></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- /bmi-status-->

      <div class="modal fade custom-modal show" id="addvitals">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Vital</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Pulse (in bpm)</label>
                        <input v-model="add_vitals.pulse" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="3" minlength="3" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Systolic Blood Pressure (in mmHg)</label>
                        <input v-model="add_vitals.bp_systolic" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="3" minlength="3" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Diastolic Blood Pressure</label>
                        <input v-model="add_vitals.bp_diastolic" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="3" minlength="3" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Temperature (C)</label>
                        <input v-model="add_vitals.temperature" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="4" minlength="2" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Height (in feet)</label>
                        <input v-model="add_vitals.height_in_feet" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="3" minlength="1" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Weight (in Kg)</label>
                        <input v-model="add_vitals.weight" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="3" minlength="2" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Random Blood Sugar</label>
                        <input v-model="add_vitals.random_blood_sugar_rbs" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="3" minlength="3" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Fasting Blood Sugar</label>
                        <input v-model="add_vitals.fasting_blood_sugar_fbs" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="3" minlength="3" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>HbA1C</label>
                        <input v-model="add_vitals.HbA1C" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="4" minlength="2" />
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" style="text-align: left">
                    <button @click="add_vitals_signs()" class="btn btn-primary submit-btn" data-dismiss="modal"
                      aria-label="Close" :disabled="isButtonDisabled">
                      Add Vital
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="viewappointment">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row d-flex justify-content-center align-items-center">
                    <div class="col-12 col-md-12 text-center">
                      <div class="form-group">
                        <img :src="config.base_url_for_Image + main_data" alt="logo" class="appointment_modal_logo"
                          height="50" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12 text-center">
                      <div class="widget-profile appointment-modal-no-border">
                        <div class="profile-info-widget">
                          <a class="booking-doc-img">
                            <img v-bind:src="appointments_details.image
                              ? config.base_url_for_Image +
                              appointments_details.image
                              : loadImg('Doctor Profile.svg')" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.practitioner_name }}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.practice }}</h5>
                      </div>
                    </div>
                    <div class="text-center ml-5">
                      <div class="col-12 col-md-12 mt-4">
                        <div class="appointment-modal text-left">
                          <b style="color: black;">Appointment Details</b>
                        </div>
                      </div>
                      <div class="col-12 col-md-12 mt-3">
                        <div class="appointment-modal text-left">
                          <label>Date :</label>
                          <label>{{ appointments_details.appointment_date }}</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-12 mt-1">
                        <div class="appointment-modal text-left">
                          <label>Time :</label>
                          <label>{{ appointments_details.appointment_time }}</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-12 mt-1">
                        <div class="appointment-modal text-left">
                          <label>Hospital :</label>
                          <label>{{ appointments_details.hospital }}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="text-center mt-4">
                    <a href="javascript:void(0);" class="btn btn-sm bg-primary-light"
                      @click="viewappointmentdata(appointments_details.name, true)">
                      <i class="fas fa-print"></i> Print
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="viewappointment1">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
              :paginate-elements-by-height="1400" filename="appointment" :pdf-quality="2" :manual-pagination="false"
              pdf-format="a4" pdf-orientation="portrait" pdf-content-width="400px" @hasDownloaded="hasGenerated($event)"
              ref="html2Pdf">
              <section slot="pdf-content">
                <div class="modal-body">
                  <div class="card">
                    <div class="card-body">
                      <div class="row form-row">
                        <div class="col-12 col-md-12 text-center">
                          <div class="form-group">
                            <!-- <img src="@/assets/img/logo/helthcare_logo.jpeg" alt="logo"
                              class="appointment_modal_logo ml-5" /> -->
                            <img :src="config.base_url_for_Image + main_data" alt="logo" class="appointment_modal_logo"
                              height="50" />
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="widget-profile appointment-modal-no-border">
                            <div class="profile-info-widget">
                              <a class="booking-doc-img">
                                <img v-bind:src="appointments_details.image
                                  ? config.base_url_for_Image +
                                  appointments_details.image
                                  : loadImg('Doctor Profile.svg')
                                  " />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>
                              {{ appointments_details.practitioner_name }}
                            </h5>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>{{ appointments_details.practice }}</h5>
                          </div>
                        </div>
                        <div class="text-center ml-5">
                          <div class="col-12 col-md-12 mt-4">
                            <div class="appointment-modal text-left">
                              <b class="ml-3" style="color:black;">Appointment Details</b>
                            </div>
                          </div>
                          <div class="col-12 col-md-12 mt-4">
                            <div class="appointment-modal text-left">
                              <label class="ml-3">Date</label>
                              <label>{{
                                appointments_details.appointment_date
                              }}</label>
                            </div>
                          </div>
                          <div class="col-12 col-md-12">
                            <div class="appointment-modal text-left">
                              <label class="ml-3">Time</label>
                              <label>{{
                                appointments_details.appointment_time
                              }}</label>
                            </div>
                          </div>
                          <div class="col-12 col-md-12 mt-1">
                            <div class="appointment-modal text-left">
                              <label class="ml-3">Hospital :</label>
                              <label>{{
                                appointments_details.hospital
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </vue-html2pdf>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appointments from "../../../assets/json/patient/appointments.json";
import prescriptions from "../../../assets/json/patient/prescriptions.json";
import medicalrecords from "../../../assets/json/patient/medicalrecords.json";
import billing from "../../../assets/json/patient/billing.json";
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
import VueHtml2pdf from "vue-html2pdf";
const images = require.context("@/assets/img/doctors");
import axios from "axios";

export default {
  components: {
    VueHtml2pdf,
  },
  Created() {
    this.get_patient_key_vital_all();
  },
  watch: {
    fake_appointments_details: {
      handler() {
        if (this.download) {
          setTimeout(this.generateReport(), 2000);
        }
      },
      deep: true,
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_practitioner_profile();
    this.get_patient_key_vital_last();
    this.get_my_appointment_list_patient();
    this.get_patient_key_vital_all();
    this.User();
  },
  data() {
    return {
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" "),
      download: false,
      fake_appointments_details: {},
      config: config,
      appointments: appointments,
      prescriptions: prescriptions,
      medicalrecords: medicalrecords,
      billing: billing,
      patient_data: {
        pulse_history: "",
        temperature_history: "",
        bp: "",
        fasting_blood_sugar_fbs_history: "",
        random_blood_sugar_rbs_history: "",
        hba1c_history: "",
        weight_history: "",
        bmi_history: "",
        bmi_unit: "",
        main_data: "",
      },
      showspinner: true,
      pulse_data: [],
      pulse_dates: [],
      temp_data: [],
      temp_dates: [],
      bp_data: [],
      bp_dates: [],
      fasting_data: [],
      fasting_dates: [],
      random_data: [],
      random_dates: [],
      hba1c_data: [],
      hba1c_dates: [],
      weight_data: [],
      weight_dates: [],
      bmi_data: [],
      bmi_dates: [],
      patient_appointment_list: [],
      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).username
        : null,
      add_vitals: {
        pulse: "",
        bp_systolic: "",
        bp_diastolic: "",
        temperature: "",
        height_in_feet: "",
        weight: "",
        random_blood_sugar_rbs: "",
        fasting_blood_sugar_fbs: "",
        HbA1C: "",
      },
      appointments_details: {
        name: "",
        practice: "",
        patient_name: "",
        practitioner_name: "",
        appointment_date: "",
        appointment_time: "",
        hospital: "",
        service_unit: "",
        image: "",
        patient_age: "",
      },
      current: 1,
      paginate: 10,
      paginate_total: 0,

      pulse_date: "",
      temp_date: "",
      bmi_date: "",
      bp_date: "",
      fbs_date: "",
      hba1c_date: "",
      rbs_date: "",
      weight_date: "",

    };
  },
  computed: {

    formattedPulseDate() {
      return this.formatDate(this.pulse_date);
    },
    formattedTempDate() {
      return this.formatDate(this.temp_date);
    },
    formattedBmiDate() {
      return this.formatDate(this.bmi_date);
    },
    formattedBpDate() {
      return this.formatDate(this.bp_date);
    },
    formattedFbsDate() {
      return this.formatDate(this.fbs_date);
    },
    formattedHba1cDate() {
      return this.formatDate(this.hba1c_date);
    },
    formattedRbsDate() {
      return this.formatDate(this.rbs_date);
    },
    formattedWeightDate() {
      return this.formatDate(this.weight_date);
    },

    isButtonDisabled() {
      const values = Object.values(this.add_vitals);
      return values.some(value => value === ""); // Button disabled if any field is empty
    },

    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),

    currentDay() {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date().getDay(); // Get the current day of the week (0-6)

      return daysOfWeek[today];
    },

    pulseflow() {
      return {
        series: [
          {
            name: "Pulse",
            data: this.pulse_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.pulse_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Pulse",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    tempflow() {
      return {
        series: [
          {
            name: "Temperature",
            data: this.temp_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.temp_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Temperature",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    bpflow() {
      return {
        series: [
          {
            name: "Bp",
            data: this.bp_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.bp_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Bp",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    fbsflow() {
      return {
        series: [
          {
            name: "Fasting Blood Sugar",
            data: this.fasting_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.fasting_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Fasting Blood Sugar",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    rbsflow() {
      return {
        series: [
          {
            name: "Random Blood Sugar",
            data: this.random_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.random_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Random Blood Sugar",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    Hba1cflow() {
      return {
        series: [
          {
            name: "HbA1C",
            data: this.hba1c_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.hba1c_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "HbA1C",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    weightflow() {
      return {
        series: [
          {
            name: "Weight",
            data: this.weight_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.weight_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "Weight",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },

    bmiflow() {
      return {
        series: [
          {
            name: "BMI",
            data: this.bmi_data,
          },
        ],
        options: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: [4, 4],
          },
          xaxis: {
            categories: this.bmi_dates,
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FF1654",
              },
              labels: {
                style: {
                  colors: "#FF1654",
                },
              },
              title: {
                text: "BMI",
                style: {
                  color: "#FF1654",
                },
              },
            },
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
    },
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }

          this.$swal.close();
        });
    },


    User() {
      if (this.user_type !== "patient") {
        this.$router.push("/doctor/index");
      }
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },


    updateCurrent(i) {
      this.current = i;
      document.getElementById("appointment_container").scrollIntoView();
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    hasGenerated(blob) {
      let url = URL.createObjectURL(blob);
      window.open(url); //opens the pdf in a new tab
    },

    viewappointmentdata(id, value) {
      this.download = value;
      this.get_appointment_popup_details(id, value);
    },

    /* Get Specific Appointment Data */
    get_appointment_popup_details(id, value) {
      var bodyFormData = new FormData();
      bodyFormData.append("name", id);
      CommonApi.post_data(
        "sahaj.api.get_appointment_popup_details",
        bodyFormData
      ).then((res) => {
        if (res.status_code == 200) {
          this.appointments_details.name = res.data[0].name;
          this.appointments_details.patient_name = res.data[0].patient_name;
          this.appointments_details.hospital = res.data[0].hospital
          this.appointments_details.practitioner_name =
            res.data[0].practitioner_name;
          this.appointments_details.appointment_date =
            res.data[0].appointment_date;
          const appointmentTimeParts = res.data[0].appointment_time.split(':');
          if (appointmentTimeParts.length === 3) { // Check if it has seconds
            const [hours, minutes, seconds] = appointmentTimeParts;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            this.appointments_details.appointment_time = `${hours % 12}:${minutes} ${ampm}`;
          } else if (appointmentTimeParts.length === 2) {
            const [hours, minutes] = appointmentTimeParts;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            this.appointments_details.appointment_time = `${hours % 12}:${minutes} ${ampm}`;
          } else {
            // Handle invalid format or missing time parts
            this.appointments_details.appointment_time = "Invalid Time";
          }

          this.appointments_details.service_unit = res.data[0].service_unit;
          this.appointments_details.image = res.data[0].doctor_photo;
          this.appointments_details.patient_age = res.data[0].patient_age;
          this.appointments_details.practice = this.get_doctor_qualification(
            res.data[0].qualification
          );

          if (value) {
            this.fake_appointments_details = res.data[0];
          }
        }
      });
    },

    get_doctor_qualification(qualification) {
      var qualification_string = [];
      qualification.map((data) => {
        qualification_string.push(data.qualification);
      });
      return qualification_string.join(" , ");
    },

    /* Get Date */
    // convertDate(str) {
    //   if (str === null || str === "") {
    //     return "";
    //   } else {
    //     var date = new Date(str),
    //       mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //       day = ("0" + date.getDate()).slice(-2);
    //     return [day, mnth, date.getFullYear()].join("-");
    //   }
    // },
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2),
          year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
        return [day, mnth, year].join("-");
      }
    },

    /* Get Time */
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },

    /* Add Vitals  */
    async add_vitals_signs() {
      this.$swal({
        text: "Adding Vitals...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        patient: this.user_id,
        attendant_name: this.username,
        ...this.add_vitals,
      };
      await CommonApi.post_data("sahaj.api.add_vital_signs", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_key_vital_last();
            this.get_patient_key_vital_all();
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.add_vitals.pulse = "";
          this.add_vitals.bp_systolic = "";
          this.add_vitals.bp_diastolic = "";
          this.add_vitals.temperature = "";
          this.add_vitals.height_in_feet = "";
          this.add_vitals.weight = "";
          this.add_vitals.random_blood_sugar_rbs = "";
          this.add_vitals.fasting_blood_sugar_fbs = "";
          this.add_vitals.HbA1C = "";
        }
      );
    },

    /* Get Patient Vital  */
    async get_patient_key_vital_last() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_patient_key_vital_last",
        params
      ).then((res) => {
        if (res) {
          this.showspinner = false;
          this.patient_data = {
            pulse_history: res.pulse_history.length
              ? res.pulse_history[0].pulse
              : 0,
            temperature_history: res.temperature_history.length
              ? res.temperature_history[0].temperature
              : 0,
            bp: res.bp.length ? res.bp[0].bp : 0,
            fasting_blood_sugar_fbs_history: res.fasting_blood_sugar_fbs_history
              .length
              ? res.fasting_blood_sugar_fbs_history[0].fasting_blood_sugar_fbs
              : 0,
            random_blood_sugar_rbs_history: res.random_blood_sugar_rbs_history
              .length
              ? res.random_blood_sugar_rbs_history[0].random_blood_sugar_rbs
              : 0,
            hba1c_history: res.hba1c_history.length
              ? res.hba1c_history[0].hba1c
              : 0,
            weight_history: res.weight_history.length
              ? res.weight_history[0].weight
              : 0,
            bmi_history: res.bmi_history.length ? res.bmi_history[0].bmi : 0,
            bmi_unit: res.bmi_history.length
              ? res.bmi_history[0].nutrition_note
              : "Graph",
          };
        }
      });
    },

    /* Get Patient All Vital  */
    async get_patient_key_vital_all() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_patient_key_vital_all",
        params
      ).then((res) => {
        if (res) {
          this.showspinner = false;

          this.pulse_date = res.pulse_history_all[0].signs_date;
          this.temp_date = res.temperature_history_all[0].signs_date;
          this.bmi_date = res.bmi_history_all[0].signs_date;
          this.bp_date = res.bp_all[0].signs_date;
          this.fbs_date = res.fasting_blood_sugar_fbs_history_all[0].signs_date;
          this.hba1c_date = res.hba1c_history_all[0].signs_date;
          this.rbs_date = res.hba1c_history_all[0].signs_date;
          this.weight_date = res.temperature_history_all[0].signs_date;

          res.pulse_history_all.map((data) => {
            this.pulse_data.push(data.pulse);
            this.pulse_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.temperature_history_all.map((data) => {
            this.temp_data.push(data.temperature);
            this.temp_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.bp_all.map((data) => {
            this.bp_data.push(data.bp);
            this.bp_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.fasting_blood_sugar_fbs_history_all.map((data) => {
            this.fasting_data.push(data.fasting_blood_sugar_fbs);
            this.fasting_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.random_blood_sugar_rbs_history_all.map((data) => {
            this.random_data.push(data.random_blood_sugar_rbs);
            this.random_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.hba1c_history_all.map((data) => {
            this.hba1c_data.push(data.hba1c);
            this.hba1c_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.weight_history_all.map((data) => {
            this.weight_data.push(data.weight);
            this.weight_dates.push(formatDate(data.signs_date)); // Format the date
          });

          res.bmi_history_all.map((data) => {
            this.bmi_data.push(data.bmi);
            this.bmi_dates.push(formatDate(data.signs_date)); // Format the date
          });
        } else {
          this.showspinner = false;
          this.temperature_history_data = [];
        }
      });

      // Function to format the date as DD-MM-YYYY
      function formatDate(dateString) {
        const date = new Date(dateString);
        const day = date
          .getDate()
          .toString()
          .padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    },

    /* Get Patient Vital  */
    async get_my_appointment_list_patient() {
      const params = new FormData();
      params.append("patient", this.user_id);
      await CommonApi.post_data(
        "sahaj.patient_api.get_my_appointment_list_patient",
        params
      ).then((res) => {
        if (res && res.status_code === 200) {
          this.showspinner = false;
          this.patient_appointment_list = res.data;
          this.paginate_total = Math.ceil(
            this.patient_appointment_list.length / this.paginate
          );
        } else {
          this.showspinner = false;
          this.patient_appointment_list = [];
        }
      });
    },
    formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
<style scoped>
.appointment-modal {
  display: block;
  text-align: center;
}

.appointment-modal-no-border {
  border: none !important;
}

table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
  /* Add an upper border */
}

th,
td {
  border: 1px solid #dddddd;
  /* You can adjust the border width and color as needed */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/patient/Index.vue